import { View } from "@react-pdf/renderer";
import { BalancoFinanceiroReceitaResponse } from "core/features/relatorios/typings";
import { PDFTable } from "ui/components/PDF";
import useRelatorioBalancoFinanceiroReceitasPdfColumns from "./hooks/useRelatorioBalancoFinanceiroReceitasPdfColumns";

interface PDFDemonstrativoReceitaEDespesaTableProps {
  items: BalancoFinanceiroReceitaResponse[];
  tableTitle: string;
}

function ReceitaTable({
  items,
  tableTitle,
}: PDFDemonstrativoReceitaEDespesaTableProps) {
  const columns = useRelatorioBalancoFinanceiroReceitasPdfColumns(tableTitle);

  return (
    <View>
      <PDFTable data={items} columns={columns} tableHeaderVariant="rowLike" />
    </View>
  );
}

export default ReceitaTable;
